import { Amount, Snils, Period } from './fields';

export const FormFieldsControls = {
  amount: Amount,
  snils: Snils,
  period: Period,
};

export const FormFieldsNavigationSequence = [
  {
    fieldName: 'amount',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'period',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'snils',
    required: false,
    checkShouldMoveToNextField: false,
  },
];
